angular.module('rjmNg.directives').directive "visualReportBuilder", [
  "dashboardService"
  "categoryCache"
  (
    dashboardService
    categoryCache
  ) ->
    restrict: "E"
    templateUrl: "directive.visualReportBuilder.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$location"
      "$modal"
      "$q"
      "$rootScope"
      "$routeParams"
      "$scope"
      "$timeout"
      "$url"
      "$window"
      "app"
      "appRoute"
      "columnDataTypes"
      "ConnectionMeta"
      "currencyService"
      "dateService"
      "dimensionService"
      "encodedLetterString"
      "figureEnums"
      "Figures"
      "figureService"
      "GoogleAnalytics"
      "logger"
      "metricDataTypes"
      "Metrics"
      "notification"
      "overdueBillingModalService"
      "reportBuilder"
      "reportBuilderScalarService"
      "reportQueryType"
      "rjpopover"
      "rjpopoverGroupNames"
      "rjql"
      "rjqlFormula"
      "rjqlStringConstants"
      "stringService"
      "StructureCache"
      "timeRangeEnums"
      "utils"
      (
        $location
        $modal
        $q
        $rootScope
        $routeParams
        $scope
        $timeout
        $url
        $window
        app
        appRoute
        columnDataTypes
        ConnectionMeta
        currencyService
        dateService
        dimensionService
        encodedLetterString
        figureEnums
        Figures
        figureService
        GoogleAnalytics
        logger
        metricDataTypes
        Metrics
        notification
        overdueBillingModalService
        reportBuilder
        reportBuilderScalarService
        reportQueryType
        rjpopover
        rjpopoverGroupNames
        rjql
        rjqlFormula
        rjqlStringConstants
        stringService
        StructureCache
        timeRangeEnums
        utils
      ) ->
        view = @
        # --- Constants --------------------------------------------------------
        RJQL_VERSION = app.getRjqlVersion()
        TIME_INTERVAL_VALUES = timeRangeEnums.TIME_INTERVAL_VALUES
        NOTIFICATION_TIMEOUT = 15
        figureId = $routeParams.figureId
        hasFigureId = figureId?
        DEFAULT_TIME_INTERVAL = TIME_INTERVAL_VALUES.MONTH
        DATE_COLUMN_TYPE = "DATETIME"
        TIME_BASED_COHORT_GROUPING_ENABLED = app.hasFeatureFlag('TIME_BASED_COHORT_GROUPING')
        DEFAULT_CURRENCY = app.getClientDefaultCurrency().code

        view.switchedToCohortView = not hasFigureId
        view.CLIENT_ID = $routeParams.clientId
        view.RJPOPOVER_GROUP_NAME = rjpopoverGroupNames.VISUAL_REPORT_BUILDER
        view.COHORT_BUILDER_ALLOWED = app.isCohortBuilderAllowed()
        view.BASE_URL = $url("")
        view.RJQL_STRING_CONSTANTS = rjqlStringConstants
        view.DATA_PERSPECTIVES = figureEnums.DATA_PERSPECTIVES
        view.CHART_TYPES = figureEnums.CHART_TYPES
        view.COHORT_CHART_TYPES = figureEnums.COHORT_CHART_TYPES
        view.IS_ADMIN_USER = app.isAdminUser()

        RESTRICTION_SET =
          restrictions: []
          sequence:
            string: null
        view.EMPTY_FORMULA_METRIC =
          name : ""
          expression : null    # The parsed-out prefix-form expression
          expressionText : ""  # The user-entered expression
          valid : undefined    # True/false if evaluated already, otherwise null
          type : "formula"
          plot: true
        view.EMPTY_METRIC =
          name : ""
          id : null
          dimensions : []
          type : "metric"
          function: "standard"
          perspective: "standard"
          plot: true
          filters:
            restrictions: []
            sequence:
              string: null
              errorMessage: null

        # --- Variable initialization ------------------------------------------
        # Used to copy an unedited version of the figure when it's first loaded
        initialLoad = true
        # Used to make sure we don't try to load a figure before our asynchronous calls come back
        loadResourcePromises = []
        queryDeferred = null
        timeIntervalMismatchWarning = null
        dimensionLimitSortingMismatchWarning = null
        view.selectedMetrics = []
        view.keyMetricIndex = null
        view.selectedChartType = 'line'
        view.activeMetricIndex = null
        view.scalars = []
        view.stopSave = false
        view.errorMessage = ''
        view.groupByValues = []
        view.metricValidity = {}
        view.cohortView = false # 'Cohort' = true, 'Standard' = false
        view.cohortDisabled = false
        view.showChart = true
        view.showTable = true
        view.savingInProgress = false
        view.displayedFigure = {}
        view.selectedMetricAlias = ''
        view.lastSaveTimestamp = null
        view.chartTypes = view.CHART_TYPES

        view.search =
          dimensionSearch: ''
          metric: ''
        view.isLoading =
          figure: hasFigureId
          table: hasFigureId
          chart: hasFigureId
          resources: true
        view.chartLegendVisible =
          checked: true
        view.freezeColumnOptions =
          checked: true
        view.hasTrendLine =
          checked: false
        view.activeMetricMenu =
          lastIndex: null # This is used to suppress the hide/show animation when a metric whose menu is visible is hidden
          index: null
          menu: null

        view.figure =
          presentation:
            highcharts:
              chart:
                type: 'line'
            table:
              transpose: false
            scalar: {}
            reportBuilder:
              table:
                visible: true
              chart:
                visible: true
            multiYAxes: true

        # Get info on the dashboard we came from, so we can go back
        if $routeParams.dashboardId?
          view.dashboard = app.getDashboard($routeParams.dashboardId)
        else
          # Need to make sure the partial doesn't try to inherit parent scope here
          view.dashboard = null

        view.time = reportBuilder.generateDefaultTime(DEFAULT_TIME_INTERVAL, RJQL_VERSION)

        loadResourcePromises.push(
          GoogleAnalytics.getDimensions(view.CLIENT_ID).then((data) ->
            view.gaStructure = data
          )
        )

        loadResourcePromises.push(
          Metrics.get(view.CLIENT_ID).then((data) ->
            view.metrics = data
          )
        )

        loadResourcePromises.push(
          StructureCache.getStructure().then((structure) ->
            view.columns = structure.columns
            view.tables = structure.tables
          )
        )

        loadResourcePromises.push(
          currencyService.fetch().then((currencies) ->
            view.currencies = currencies.data
          )
        )

        # We're going to need this later, but want to start tracking it now to avoid race conditions
        gaConnectionsDeferred = $q.defer()
        loadResourcePromises.push(gaConnectionsDeferred)

        # Grab GA Metrics
        loadResourcePromises.push(
          GoogleAnalytics.getMetrics(view.CLIENT_ID).then((gaMetricList) ->
            view.gaMetricList = gaMetricList
            _loadGaConnections(gaConnectionsDeferred, gaMetricList)
          )
        )


        # --- Functions --------------------------------------------------------

        _logEvent = (type) ->
          if hasFigureId
            logger.log(type, "Open", 1, "edit")
          else
            logger.log(type, "Open", 1, "create")

        _parseGaConnectionName = (name) ->
          results = name.match(/^.*\(*Profile\)*\s(.*)$/)?[1]
          if results?
            return results
          else
            return name

        _generateGaMetrics = (metricList, connection) ->
          metrics = []
          isGA4Live = connection.meta.connection.type is "google_analytics4_live"
          parsedName = _parseGaConnectionName(connection.meta.name)
          for template in metricList
            if((isGA4Live && (template.type is 2)) || (!isGA4Live && (template.type is 1)))
              metric =
                id: [connection.id, template.data]
                numericalId: template.id
                name: if isGA4Live then "#{template.name}" else "#{parsedName} - #{template.name}"
                webPropertyId: connection.meta.connection.webPropertyId
                isGA4Live: isGA4Live
              metrics.push metric
          return metrics

        _loadGaConnections = (gaConnectionsPromise, gaMetricList) ->
          # Grab each connection using the ConnectionMeta
          ConnectionMeta(view.CLIENT_ID).gaConnections().then((connections) ->
            connections ?= []
            view.gaConnections = connections.map (conn) ->
              name: _parseGaConnectionName(conn.meta.name)
              metrics: _generateGaMetrics(gaMetricList, conn)
              webPropertyId: conn.meta.connection.webPropertyId

            # We can resolve this now
            gaConnectionsPromise.resolve()
          )

        view.switchToStandardView = () ->
          if view.cohortView
            _logEvent("Report Builder Usage")

            # Close all rj-popovers and remove active index
            rjpopover.hideGroup(view.RJPOPOVER_GROUP_NAME)
            view.removeActiveMetricIndex()

            metric = view.selectedMetrics[0]
            metric.perspective = 'standard'
            view.removeAllDimensions()

            view.cohortView = false

            # Restore default view.time (it will updateReport)
            view.time = reportBuilder.generateDefaultTime(DEFAULT_TIME_INTERVAL, RJQL_VERSION)

        view.switchToCohortView = () ->
          if not view.cohortDisabled and not view.cohortView
            _logEvent("Cohort Report Builder Usage")

            view.switchedToCohortView = true

            cohortMetric = view.selectedMetrics[0]
            cohortMetric.perspective = 'standard'

            cohortTimeStampDimension = dimensionService.getCohortTimeStampDimensions(
              cohortMetric.dimensionList,
              cohortMetric.timestampColumnId,
              view.columns
            )[0]
            view.removeAllDimensions()
            view.addDimension(cohortTimeStampDimension)

            cohortMetric['counting-members'] = reportBuilder.getCountingMembers(cohortMetric, view.columns)

            # Restore metric alias in case user changed it
            delete view.metricValidity[cohortMetric.alias]
            cohortMetric.alias = cohortMetric.name
            view.updateMetricValidity()

            view.setChartType('line', false)

            view.cohortView = true

            # Update view.time to support cohorts (it will updateReport)
            view.time = reportBuilder.generateDefaultTime(DEFAULT_TIME_INTERVAL, RJQL_VERSION, true, cohortTimeStampDimension.column_id)

            # Show cohort editor rjpopover
            $timeout () ->
              rjpopover.showOrHideByIndex(view.RJPOPOVER_GROUP_NAME, "metric-#{view.selectedMetrics[0].uniqueId}", true)

        view.checkIfCohortDisabled = () ->
          view.cohortDisabled = if not view.COHORT_BUILDER_ALLOWED or
            view.selectedMetrics.length > 1 or
            (view.selectedMetrics[0]? and
              (view.selectedMetrics[0].isGaMetric or
              dimensionService.getCohortTimeStampDimensions(
                view.selectedMetrics[0].dimensionList
                view.selectedMetrics[0].timestampColumnId,
                view.columns
               ).length is 0 or
               view.selectedMetrics[0].hasCustomTimeRange or
               view.selectedMetrics[0].timeUnbound))
               then true else false

        view.truncateMetricName = (metric) ->
          return stringService.truncateString(metric.name, 30)

        view.getKeyMetric = () ->
          return view.selectedMetrics[view.keyMetricIndex]

        view.saveSuccessCallback = (figure, dashboard) ->
          currentDate = new Date()

          view.dashboard = dashboard
          view.lastSaveTimestamp = currentDate.getTime()

          # Update this so we don't get an 'Are you sure you want to leave without saving?' message.
          view.pristineFigure = utils.copy(view.figure)
          # This doesn't get updated immediately
          view.pristineFigure.presentationType = figure.presentationType

          # Broadcast message so dashboard knows to delete this figure from local cache
          $rootScope.$broadcast('reloadRjqlFigure', view.figure?.rjqlId)

        view.saveErrorCallback = () ->
          view.lastSaveTimestamp = null

        setMetricOrderFromPresentation = (metrics) ->
          return metrics unless view.figure?.presentation?.reportBuilder?.metricOrder?
          orderedMetrics = utils.matchArrayOrder(
            view.figure.presentation.reportBuilder.metricOrder
            metrics
            (metric) -> metric.alias
          )
          updateFormulaAliases(orderedMetrics)
          return orderedMetrics

        # Loads a figure into the report builder
        view.loadFigure = () ->
          view.isLoading.figure = true

          # We don't need the data yet, but we do need the query
          requestOptions = Figures.getRequestOptions(false, true)

          Figures.get(figureId, false, requestOptions)
          .then (figureModel_DO_NOT_MUTATE) ->
            # Don't change the figure directly because we don't want to mutate the cached model
            figure = utils.copy figureModel_DO_NOT_MUTATE
            view.figure = utils.copy figure

            queryMeta =
              from: figureService.mapOverFromSafe(figure.query, (f) -> f)
              metricIds: figureService.getMetricIdsFromFigure(figure)
              measures: figureService.getMeasuresFromFigure(figure)
              dimensions: figureService.getDimensionsFromFigure(figure)
              filters: figureService.getFiltersFromFigure(figure)
              orders: figureService.mapOverFromSafe(figure.query, (f) -> f.order)

            # Group by value filters are special in the report builder
            # We need to store their values here
            if queryMeta.dimensions[0]?.length > 0
              groupByValueFilters = figureService.getGroupByFiltersFromFigure(figure)
              view.groupByValues = reportBuilder.getValuesFromGroupByValueFilters(
                groupByValueFilters,
                queryMeta.dimensions[0]
              )

            # Set time range properties
            view.time.range = figure.query.range
            view.time.timerange = figureService.getTimeRangeFromFigure(figure, RJQL_VERSION)
            view.time.interval = figureService.getTimeInterval(view.figure)

            _setPresentationOptions()

            # Send edit event to the journal
            if view.cohortView
              _logEvent("Cohort Report Builder Usage")
            else
              _logEvent("Report Builder Usage")

            # Load an array of promises to load metrics
            loadMetricPromises = _loadMetricsHelper(figure, view.metrics, view.gaConnections, queryMeta)

            # Once metrics are all loaded, load measures
            $q.all(loadMetricPromises).then( (metrics) ->

              _loadMeasures(metrics, figure, queryMeta.measures)
              view.selectedMetrics = setMetricOrderFromPresentation(metrics)
              view.updateMetricValidity()
              setKeyMetric()

              view.time.intervalEnabled = view.canSelectTimeInterval()

              # Set the local scope's category cache for chosen dimensions
              if queryMeta.dimensions.length > 0
                for column_id in queryMeta.dimensions[0]
                  categoryCache.getByDimension(
                    {column_id}
                    view.getKeyMetric()
                  )

              # Do a full update now that everything is set
              view.isLoading.figure = false

              # If extra filters are applied on the dashboard we need to reload the report
              # We need to always force a reload with dash-wide filtering
              # Do that only if they have the FF enabled for now
              forceUpdateReports = dashboardService.extraDashboardFilters.length > 0 or app.hasFeatureFlag('DASHBOARD_WIDE_TIME_RANGES')
              view.updateReport(forceUpdateReports)
              view.checkIfCohortDisabled()
            )
          .catch (error) ->
            notification.error "Error!", "There was a problem loading this figure.", "report"
            view.isLoading.resources = false

        # Find metric from id
        _getMetricById = (id, metrics) ->
          for metric in metrics when metric.id is id
            return metric

        # Find GA metrics by Id
        _getGaMetricById = (id, gaConnections) ->
          for connection in gaConnections
            metrics = connection.metrics
            for metric in metrics when _(metric.id).isEqual(id)
              return metric

        _addFilterToMetric = (metric, filter) ->
          if filter?
            newFilter = angular.copy(filter)

            # Convert the prefix to infix
            newFilter.sequence.string = rjqlFormula.convertPrefixArrayToInfixString(filter.sequence.string)
            metric.filters = newFilter
          return metric

        # Set presentation options
        _setPresentationOptions = ->
          view.cohortView = figureService.isCohortFigure(view.figure)
          view.figure.presentation.reportBuilder = reportBuilder.getReportBuilderPresentation(view.figure)
          view.showChart = view.figure.presentation.reportBuilder?.chart?.visible
          view.showTable = view.figure.presentation.reportBuilder?.table?.visible

          view.selectedChartType = figureService.getChartTypeFromFigure(view.figure)
          if view.selectedChartType is 'column' and figureService.figurePresentationIsStacked(view.figure)
            view.selectedChartType = 'columnstacked'

          if view.selectedChartType is 'bar' and figureService.figurePresentationIsStacked(view.figure)
            view.selectedChartType = 'barstacked'

          view.chartLegendVisible.checked = figureService.doesFigureHaveEnabledLegend(view.figure)
          view.freezeColumnOptions.checked = view.figure.presentation?.table?.freezeColumns ? false

        # Wrapper to decide which metric path to take
        _loadMetricsHelper = (figure, metrics, gaConnections, {metricIds, from, filters, dimensions, orders}) ->
          loadMetricPromises = []
          for newMetricId, index in metricIds
            if newMetricId instanceof Array
              metric = _getGaMetricById(newMetricId, gaConnections)
            else
              metric = _getMetricById(newMetricId, metrics)

            if metric?
              loadMetricPromises.push _loadMetricHelper(figure, metric, from, filters, dimensions, index, orders)
            else
              notification.error "Error!", "There was a problem loading a metric that defines this report. Please contact #{app.getSupportEmail()} for assistance.", "report"

          return loadMetricPromises

        # Loads in a regular metric
        _loadMetricHelper = (figure, metric, from, filters, dimensions, fromIndex, orders) ->

          newMetric = utils.copy(metric)
          # Use the type to set the data perspective using our common method
          # This is important because there is some data we actually throw away from the query
          # such as the specified time unit unless this is something like amountVsPreviousYear

          newMetric.alias = from[fromIndex].alias
          newMetric.alias ?= metric.name

          # I'm still not sure there won't be cases we we have to make a dispute over which data
          # perspective to apply.  These should all match, but in the future if there are
          # cases where we have more than one type here we may have to generate multiple
          # metrics from the possibilities
          possibleDataPerspectives = figureService.getDataPerspectiveByMetricAlias(newMetric.alias, figure)

          # Get the perspective type
          perspectiveType = figureService.identifyDataPerspective(possibleDataPerspectives[0], RJQL_VERSION)
          perspectiveType ?= 'standard'

          newMetric.perspective = perspectiveType

          # Get the window length from query if rolling average perspective
          if newMetric.perspective is 'rollingAverage'
            newMetric.averageWindowLength = figureService.getWindowLengthByMetricAlias(newMetric.alias, figure)

          # Set filters and dimensions
          if filters[fromIndex]?
            newMetric = _addFilterToMetric(newMetric, filters[fromIndex])

          newMetric.dimensions = []
          newMetric.dimensions = dimensions[fromIndex]?.map (column_id) -> {column_id}

          if view.cohortView
            newMetric['counting-members'] = figureService.getCountingMembersFromFigure(figure)

          if from[fromIndex].timerange?
            from[fromIndex].bind ?= {}
            from[fromIndex].bind.time = view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND

          newMetric.timeUnbound = from[fromIndex].bind?.time is view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND

          # Load the custom time range, but only if the metric is unbound from time
          if newMetric.timeUnbound and from[fromIndex].timerange?
            newMetric.customTimeRange = from[fromIndex].timerange
            newMetric.hasCustomTimeRange = true

          # Add order by and limits
          newMetric.order = orders[fromIndex]

          # Call our loading function, which bypasses some of the initialization
          # code that metrics get when you add them from scratch
          return loadMetric(newMetric, fromIndex)

        # Convert a measure returned by the reportBuilderService to a form usable by
        # the Report Builder.
        loadFormulaMetric = (metrics, measure) ->
          newFormulaMetric = utils.copy(measure)
          newFormulaMetric.alias = measure.label
          newFormulaMetric.uniqueId = getUniqueMetricId()
          newFormulaMetric.plot = true
          newFormulaMetric.assignedType =
            type: measure.dataType ? metricDataTypes.DATA_TYPES.nonMonetary
            currencyCode: measure.currencyCode ? DEFAULT_CURRENCY

          newFormulaMetric.expressionText =
            rjqlFormula.convertPrefixMetricExpressionToInfixFormula(
              newFormulaMetric.expression
              metrics
            )

          rjqlFormula.applyFormula(metrics, newFormulaMetric, RJQL_VERSION)

          return newFormulaMetric

        # Loop through the measures.  We need to add calculated metrics if we find them.
        # We may also have to unhide source metrics
        _loadMeasures = (metrics, figure, measures) ->
          for measure in measures
            if measure.expression?
              metrics.push loadFormulaMetric(metrics, measure)
            else
              # Always display source metrics in single source charts
              if figureService.isSingleSourceFigure(figure) or metrics.length is 1
                metrics[0]?.plot = true
              else
                # Show source metrics if they have corresponding measures
                for metric in metrics
                  if measure instanceof Array
                    if measure[0] is metric.alias
                      metric.plot = true
                  else
                    if measure.field[0] is metric.alias
                      metric.plot = true

        # The showAllGroupByValues parameter is used for cases when we want to ignore the
        # group by filters and return data for all dimension values, such as in the table view
        view.generateQueryFromSelectedMetrics = (selectedMetrics, keyMetric, showAllGroupByValues=false) ->
          rows = null
          if keyMetric? and keyMetric.dimensions.length > 0
            rows = keyMetric.dimensions.map((dim) -> {name: dim.name})

          if view.cohortView
            columns = [
              alias: view.RJQL_STRING_CONSTANTS.RJQL_PERIODDIFF
              args: [
                view.time.timerange[1].field
                view.RJQL_STRING_CONSTANTS.RJQL_TIME
                view.time.interval
              ]
              function: "perioddiff"
              label: view.time.interval
              type: "function"
            ]
          else if view.time.interval isnt TIME_INTERVAL_VALUES.NONE
            columns = [interval: view.time.interval]
          else
            columns = null

          rjQuery = rjql.generateQuery(selectedMetrics, rows, columns, view.time.timerange, view.time.range, showAllGroupByValues, RJQL_VERSION)
          return rjQuery

        _makeMessage = (type, reason) ->
          return "#{type} charts aren't compatible with this setup. #{reason}"

        _modifyForStyleConstraints = (figure) ->
          type = figureService.getChartTypeFromFigure(figure)
          modificationNeeded = false

          if type in ['pie', 'funnel'] and not figureService.isPieFunnelAllowed(figure)
            modificationNeeded = true
            timeInterval = figureService.getTimeInterval(figure)
            grouped = figureService.isGroupedByDimension(figure)

            if figureService.isSingleSourceFigure(figure)
              if timeInterval isnt TIME_INTERVAL_VALUES.NONE or not grouped
                message = _makeMessage(
                  stringService.upperCaseFirst(type),
                  "The data must be grouped by one or more columns \
                   and the time interval must be set to 'None'."
                )
            else
              if timeInterval isnt TIME_INTERVAL_VALUES.NONE or grouped
                message = _makeMessage(
                  stringService.upperCaseFirst(type),
                  "The data should not be grouped by columns \
                   and the time interval must be set to 'None'."
                )

          if type in ['scatter', 'scattertrendline'] and not figureService.isScatterBubbleAllowed(figure)
             modificationNeeded = true
             message = _makeMessage(
               "Plotted Points",
               "The data must have two metrics, with an optional third metric, \
                only be grouped by one column, or by time interval."
             )

          if type is 'heatmap' and not figureService.isHeatMapAllowed(figure)
            modificationNeeded = true
            message = _makeMessage(
              "Heat map",
              "The data must have one metric, be grouped by two columns with \
               time interval set to none, or grouped by one column with time interval set."
            )

          if modificationNeeded
            figure = figureService.setChartType(figure, 'line')
            view.setChartType('line')
            notification.warning('Change report style', message, 'global')
          return figure

        view.redrawChartAndTable = (data, query) ->
          # We should already have the latest query, but this updates the data
          view.figure = _generateFigure(query, data, view.figure.presentation)

          view.figure = _modifyForStyleConstraints(view.figure)
          # Have to update the presentation data for y-axes in case more metrics are
          # now on figure
          _updatePresentationFromScope()

          # This will kick off a render of the figure with the latest query and data
          view.displayedFigure = utils.copy(view.figure)

          view.scalars = reportBuilderScalarService.getScalars(
            view.displayedFigure
            view.selectedMetrics
            view.time.timerange
            RJQL_VERSION
          )

        _updateSourceMetrics = () ->
          # Make sure we don't try to set a data limit with a time interval
          unless view.time.interval is TIME_INTERVAL_VALUES.NONE
            metric.order = _getDefaultOrder() for metric in view.selectedMetrics when metric.type is 'metric'

          metric.dimensionValues = angular.copy(view.groupByValues) for metric in view.selectedMetrics

        # If only one metric is selected, that metric is unbound from time, and the global time interval is non-null, set the mismatch flag;
        # In all conditions, clear the mismatch flag.
        _updateGlobalTimeIntervalMismatch = () ->

          if view.selectedMetrics.length > 0
            keyMetric = view.getKeyMetric()

            if view.selectedMetrics.length is 1 and keyMetric.type is 'metric' and
              keyMetric.timeUnbound and view.time.interval isnt TIME_INTERVAL_VALUES.NONE
                keyMetric.globalTimeIntervalMismatch = true
                if not timeIntervalMismatchWarning?
                  timeIntervalMismatchWarning = notification.warning(
                    'Time Interval Mismatch',
                    "The metric's time interval doesn't match this report's time
                    interval. They should match when you only include one metric.",
                    'global'
                  )
                return
            else
              for metric in view.selectedMetrics
                if metric.globalTimeIntervalMismatch?
                  delete(metric.globalTimeIntervalMismatch)

          if timeIntervalMismatchWarning?
            notification.remove(timeIntervalMismatchWarning, timeIntervalMismatchWarning.notificationScope)
            timeIntervalMismatchWarning = null

        # If a metric is dimensioned and ordered, ensure the ordering matches one of the dimensions
        _checkDimensionSorting = () ->
          if dimensionLimitSortingMismatchWarning?
            notification.remove(dimensionLimitSortingMismatchWarning, dimensionLimitSortingMismatchWarning.notificationScope)
            dimensionLimitSortingMismatchWarning = null

          [dimensionSortingValid, mismatchedMetric] = reportBuilder.dimensionSortingIsValid view.selectedMetrics

          if not dimensionSortingValid
            $scope.$broadcast('openTopBottomDropdown')
            dimensionLimitSortingMismatchWarning = notification.warning('Select Ordering', "Choose a sorting dimension for metric '#{mismatchedMetric.alias}'", 'global')

          return dimensionSortingValid

        _addIndexToDimensions = (dimensions) ->
          dimensionsHaveIndex = (dimensions) ->
            _.every(dimensions, (dimension) ->
              _.has(dimension, "sortableDimensionIndex")
            )

          if not dimensionsHaveIndex(dimensions)
            indexedDimensions = _.map(dimensions, (dimension) ->
              dimension.sortableDimensionIndex = _.uniqueId('dimension')
              return dimension
            )
          else
            # dimensions already ALL have indices
            indexedDimensions = dimensions

          return indexedDimensions

        _removeIndexFromDimensions = (dimensions) ->
          _.map(dimensions, (dimension) ->
            _.omit(dimension, 'sortableDimensionIndex')
          )

        # if there is at least one unbound dimension set all dimensions to be unbound
        _setUnboundDimensions = (dimensions) ->
          unboundDimension = _.find(dimensions, (dimension) ->
            dimension.column_id is view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND)

          # only do this if there is at least one unbound dimension
          if unboundDimension?
            return _.map(dimensions, (dimension) ->
              dimension.name = view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND_NAME
              dimension.column_id = view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND
              dimension
            )

          dimensions

        # If metric is a GA metric, then sets default timerange and shows info notification
        _setDefaultTimeRangeIfGaMetric = (metric) ->
          if metric.isGaMetric and
            dateService.isStaticRangeAllTime(view.time.timerange) and
            not (metric.hasCustomTimeRange and metric.timeUnbound)

              notification.info(
                "Cannot choose All-Time",
                "Google Analytics prevents the use of the All-Time time range. The time range in this report was automatically adjusted to show the last 2 years.",
                "report",
                null,
                NOTIFICATION_TIMEOUT
              )
              view.time.timerange = dateService.getMovingTimeRangeFromType(
                timeRangeEnums.MOVING_TIME_RANGE_TYPES.LAST_24_MONTHS,
                RJQL_VERSION
              )

        view.removeIndicesUpdateReport = (metric) ->
          metric.dimensions = _removeIndexFromDimensions(metric.dimensions)
          view.updateReport()

        view.updateGroupByValues = (groupByValues) ->
          view.groupByValues = angular.copy(groupByValues)

        view.updateReport = (forceUpdate=true) ->
          # Don't run the query if there are no selected metrics
          if view.selectedMetrics.length is 0
            return

          # If there are GA metrics in selected Metrics, then we have to make sure there is a time range set
          for metric, index in view.selectedMetrics
            _setDefaultTimeRangeIfGaMetric(metric)

          keyMetric = view.getKeyMetric()

          # add index to dimensions to allow tracking and sorting
          keyMetric.dimensions = switch
            when keyMetric.dimensions?.length > 0
              _addIndexToDimensions(keyMetric.dimensions)
            else []

          _updateGlobalTimeIntervalMismatch()

          # Ensure all formulas/filters are valid
          if not _filtersAndFormulasAreValid()
            return

          # We may need to update some source metrics
          _updateSourceMetrics()

          # Ensure the dimension ordering matches a dimension
          if not _checkDimensionSorting()
            return

          view.isLoading.table = true
          view.isLoading.chart = true

          if forceUpdate or not view.figure.query? or not view.figure.data?
            keyMetric = view.getKeyMetric()
            rjQuery = view.generateQueryFromSelectedMetrics(view.selectedMetrics, keyMetric, false)

            # Cancel the previous query if its still pending
            if queryDeferred?
              queryDeferred.reject({status: -1})
            queryDeferred = $q.defer()

            if _showPreview()
              rjql.runQueryCached(
                view.CLIENT_ID,
                rjQuery,
                queryDeferred,
                RJQL_VERSION,
                app.hasFeatureFlag('RJQL_SERVICE_DEBUG')
              ).then(
                (success) -> _handleQuerySuccess(success, rjQuery, true),
                (failure) -> _handleQueryFailure(failure, rjQuery)
              )
          else
            rjQuery = view.figure.query
            _handleQuerySuccess(view.figure, view.figure.query)

          # Make sure our presentation object gets updated before we resave the figure
          _updatePresentationFromScope()

          # Update our figure before our query comes back, so if we save prior to the
          # request response, we get the latest version
          view.figure = _generateFigure(rjQuery, view.figure.data, view.figure.presentation)

        _showPreview = () ->
          return view.showTable or view.showChart

        view.aliasIsUnique = (metricIndex) ->
          for metric, index in view.selectedMetrics when index isnt metricIndex and
            metric.alias is view.selectedMetrics[metricIndex].alias
              return false
          return true

        _handleQuerySuccess = (result, query, clearError = false) ->
          if clearError
            view.figure.error = null
          view.redrawChartAndTable(result.data, query)
          if initialLoad
            # Make a copy of the figure so we can tell if it's been edited later
            view.pristineFigure = utils.copy(view.figure)
            initialLoad = false
          view.stopSave = false
          if result.data?.warnings?
            result.data.warnings.map (warning) ->
              #So far, only this one is implemented
              if warning.code is figureEnums.WARNING_CODES.DATA_TRUNCATED
                notification.clear "report"
                notificationMessage = if figureEnums.WARNING_MESSAGES[warning.code] then figureEnums.WARNING_MESSAGES[warning.code] else warning.message
                notification.warning "500 (Internal Server Error)", notificationMessage, "report"
          view.isLoading.chart = false
          view.isLoading.table = false

        _handleQueryFailure = (result, query) ->
          unless utils.requestWasCanceled(result)
            if result.data?.error?.stopSave?
              view.stopSave = true
              result.data.error.message = result.data.error.message + " Contact #{app.getSupportEmail()} for assistance."
              view.errorMessage = result.data.error.message
            notification.clear "report"
            notificationMessage = if result.data.error?.message? then result.data.error.message else "Sorry, something went wrong. Please reload."
            notification.error "500 (Internal Server Error)", notificationMessage, "report"
            view.isLoading.chart = false
            view.isLoading.table = false

        _generateFigure = (query, response, presentation) ->
          figure = utils.copy(view.figure)
          figure.query = query
          figure.data = response
          figure.presentation = presentation
          figure.type =
            id: 1
          figure.presentationVersion = 0.1
          figure.state =
            id: 1
          figure.description ?= ""
          figure.reportQueryType = reportQueryType.RJQL

          unless figure.presentation.table?
            figure.presentation.table =
              transpose: false

          unless view.showChart
            figure.presentation.reportBuilder.chart.visible = false

          unless view.showTable
            figure.presentation.reportBuilder.table.visible = false

          return figure

        _getDefaultOrder = () ->
          limit:
            take: "100%"
          fields: [[":value",":desc"]]

        view.addFormulaMetric = ->

          newFormulaMetric = utils.copy(view.EMPTY_FORMULA_METRIC)

          newFormulaMetric.alias = "Untitled"
          newFormulaMetric.assignedType =
            type: metricDataTypes.DATA_TYPES.nonMonetary
            currencyCode: DEFAULT_CURRENCY

          newFormulaMetric.alias = _getUniqueMetricAlias(newFormulaMetric.alias)
          newFormulaMetric.uniqueId = getUniqueMetricId()

          view.selectedMetrics.push newFormulaMetric

          # Set this to the active metric so the user knows he needs to enter in a formula
          view.setActiveMetricIndex(view.selectedMetrics.indexOf(newFormulaMetric))
          $timeout () ->
            rjpopover.showOrHideByIndex(view.RJPOPOVER_GROUP_NAME, "metric-#{newFormulaMetric.uniqueId}", true)

          view.checkIfCohortDisabled()

        _filtersAndFormulasAreValid = () ->
          for metricAlias, metricValid of view.metricValidity
            if not metricValid
              alert "Can't reload chart. Fix error on '#{metricAlias}' metric."
              return false
            if metricValid is 'blank'
              alert "Can't reload chart. The formula for '#{metricAlias}' is blank."
              return false
          return true

        # Copies metric details from toMetric to fromMetric.
        _addMetricInfoToMetric = (fromMetric, toMetric) ->
          toMetric.isGaMetric = reportBuilder.isGaMetric(fromMetric)
          if not toMetric.isGaMetric
            toMetric.tableId = fromMetric.table_id
            toMetric.tableName = view.tables[fromMetric.table_id]?.name
            toMetric.columnId = fromMetric.operation_column_id
            if fromMetric.timestamp_column_id?
              toMetric.timestampColumnId = fromMetric.timestamp_column_id
            else
              delete toMetric.timestampColumnId
            toMetric.command = stringService.toTitleCase(fromMetric.command)

            if view.columns?
              toMetric.columnName = view.columns[toMetric.columnId]?.name if toMetric.columnId?
              if toMetric.timestampColumnId?
                toMetric.timestampColumnName = view.columns[toMetric.timestampColumnId]?.name
              else
                delete toMetric.timestampColumnName
          else
            toMetric.webPropertyId = fromMetric.webPropertyId

        _metricHasTimestamp = (metric) ->
          return reportBuilder.isGaMetric(metric) or
            metric.timestamp_column_id? or
            (metric.subscription_start_column_id? and
             metric.subscription_end_column_id?)

        # Use this when loading one or more metrics in at a time from the backend
        loadMetric = (metric, index) ->
          newMetric = utils.copy(metric)
          newMetric.type = 'metric'
          newMetric.plot = false
          newMetric.hasTimestamp = _metricHasTimestamp(metric)

          # Add metric info
          _addMetricInfoToMetric(metric, newMetric)

          # If we have no filters, give it an empty set
          newMetric.filters ?= utils.copy(RESTRICTION_SET)
          newMetric.order ?= _getDefaultOrder()

          return _addMetric(newMetric, false, index)

        # Use this when adding a new metric
        view.addMetric = (metric) ->

          newMetric = utils.copy(view.EMPTY_METRIC)
          newMetric.id = metric.id
          # Used by GA
          newMetric.numericalId = if metric.numericalId? then metric.numericalId else metric.id
          newMetric.name = metric.name
          newMetric.alias = metric.name
          newMetric.order = _getDefaultOrder()
          newMetric.isGA4Live = metric.isGA4Live
          newMetric.hasTimestamp = _metricHasTimestamp(metric)

          # Add metric info
          _addMetricInfoToMetric(metric, newMetric)

          if not newMetric.hasTimestamp
            newMetric.timeUnbound = true
            newMetric.plot = true
          else
            newMetric.timeUnbound = false

          newMetric = _addMetric(newMetric, true, null)

          _newMetricIndicator(view.selectedMetrics.length)

        _newMetricIndicator = (metricsLength) ->

          view.newlyAddedMetricIndex = metricsLength
          $timeout ->
            view.newlyAddedMetricIndex = null
          , 600

        _getMetricIndexWithBoundDimensions = (metrics, excludeIndex = null) ->
          for metric, index in metrics when metric.type is 'metric' and (not excludeIndex? or excludeIndex isnt index) 
            boundDimensions = metric.dimensions.map (dim) ->
              dim.column_id isnt view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND

            # not all dimensions are bound so we need to look at other metrics
            if not _.every(boundDimensions)
              continue

            # all dimensions are bound, found our key metric
            return index

          null

        setKeyMetric = () ->
          view.keyMetricIndex = _getMetricIndexWithBoundDimensions(view.selectedMetrics)

        view.countGroupableDimensions = () ->
          if view.selectedMetrics.length > 0
            keyMetric = view.getKeyMetric()
            count = 0
            for dimension in keyMetric.dimensionList
              if dimension.is_groupable
                count += 1
            return count
          else
            return 0

        view.openMetricSettings = () ->
          keyMetric = view.getKeyMetric()
          editUrl = appRoute('/settings/metric/edit/' + keyMetric.id)
          $window.open( editUrl, "Settings Page" )
          return true

        # Returns a string which is used to associate metrics with DOM elements.
        # When metrics are soreted, we generate a new id for each metric to force a
        # full update of the scalar DOM.
        getUniqueMetricId = () ->
          _.uniqueId('metric')

        # Adds a new metric to the chart
        _addMetric = (newMetric, forceUpdate, fromIndex) ->
          metricAdded = $q.defer()
          # Grab the available dimensions for this metric
          dimensionPromise = reportBuilder.loadAvailableDimensions(newMetric, view.columns)

          # Make sure any current dimensions being applied are valid and if not,
          # use the metric resolver to force the user to pick ones that do
          if view.selectedMetrics.length > 0
            keyMetric = view.getKeyMetric()

          resolvedDimensionsPromise = view.resolveDimensions(
            dimensionPromise
            view.selectedMetrics
            keyMetric
          )

          # We should now have a list of resolved dimensions to add to this metric
          $q.all(resolvedDimensionsPromise).then( (response) ->
            resolvedDimensions = response.promise
            
            newMetric = reportBuilder.addResolvedDimensionsToMetric(newMetric, resolvedDimensions, view.columns, view.gaStructure)

            # Get a unique name for this metric
            newMetric.alias = _getUniqueMetricAlias(newMetric.alias)
            view.metricValidity[newMetric.alias] = true
            newMetric.uniqueId = getUniqueMetricId()

            # Is this a GA metric?  If so, we have to make sure there is a timerange set
            _setDefaultTimeRangeIfGaMetric(newMetric)

            unless newMetric.hasTimestamp
              view.setTimeInterval(TIME_INTERVAL_VALUES.NONE)

            # Maintain order if we're loading them in asynchronosly
            if fromIndex?
              newMetric.index = fromIndex
            else
              view.selectedMetrics.push newMetric
              setKeyMetric()

            newMetric.order ?= _getDefaultOrder()

            view.time.intervalEnabled = view.canSelectTimeInterval()

            if not newMetric.isGaMetric and view.columns?
              if newMetric.columnId?
                newMetric.columnName = view.columns[newMetric.columnId]?.name

              if newMetric.timestampColumnId?
                newMetric.timestampColumnName = view.columns[newMetric.timestampColumnId]?.name

            if forceUpdate
              view.updateReport()
            metricAdded.resolve(newMetric)

            view.checkIfCohortDisabled()

            if not newMetric.isGaMetric
              _addFilterInfoToMetric(newMetric)
          )
          return metricAdded.promise

        _addFilterInfoToMetric = (nm) ->
            nm.filterLoading = true
            nm.filterInfo = false
            nm.filterError = false
            Metrics.getFullMetricInfo(view.CLIENT_ID, nm.id).then (response) ->
              nm.editUrl = appRoute('/settings/metric/edit/' + nm.id)
              nm.filterLoading = false
              nm.filterInfo = 
                filters: response.filters
                sequence: response.sequence
            , (error) ->
              nm.filterError = true 
              nm.filterLoading = false

        _getUniqueMetricAlias = (originalAlias) ->
          aliases = view.selectedMetrics.map (metric) -> return metric.alias
          return stringService.getUniqueString(aliases, originalAlias)

        # Pop open the group by value menu
        _showGroupByValueMenuAfterDigest = (dimIndex) ->
          $timeout ->
            rjpopover.showOrHideByIndex(view.RJPOPOVER_GROUP_NAME, "dimension-#{dimIndex}", true)

        view.addDimension = (selectedDimension, doAutoSelect=true, showPopover=true) ->
          view.groupByValues.push {}
          # If this fails it kicks off the dimension conflict resolution modal
          if _isDimensionAvailableAndResolveIt(view.selectedMetrics, selectedDimension)

            # Put this dimension on all metrics
            for metric in view.selectedMetrics when metric.type is 'metric'
              metric.dimensions.push selectedDimension
              metric.dimensions = _removeIndexFromDimensions(metric.dimensions)
              metric.dimensions = _addIndexToDimensions(metric.dimensions)
              metric.dimensions = _setUnboundDimensions(metric.dimensions)

            keyMetric = view.getKeyMetric()

            if showPopover
              _showGroupByValueMenuAfterDigest(keyMetric.dimensions.length - 1)

            # Exclude time dimensions for now, because wrong time format (example '2017-11-16 12:00:00+00') cause error in rjql-service
            if selectedDimension.datatype isnt DATE_COLUMN_TYPE and doAutoSelect
              # Grab this now so if we want to group by value, we already have it
              categoryCache.getByDimension(
                selectedDimension
                keyMetric
              ).then( (result) -> _autoSelectGroupByValue(result) )

        # Used to auto select some group by values when choosing a new dimension
        _getAutoSelectedGroupByValues = (values) ->
          result = []
          if values instanceof Array
            length = if values.length > 5 then 4 else values.length
            result = (item.id for item in values[0..length])
          return result

        _autoSelectGroupByValue = (result) ->
          keyMetric = view.getKeyMetric()

          if keyMetric.dimensions[0].column_id is view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND
            return

          # Add a new object to the groupByValues array
          dimIndex = keyMetric.dimensions.length - 1
          preSelectedGroupByValues = _getAutoSelectedGroupByValues(result.categoryValues)

          # If we get nothing that probably means we have high cardinality
          if preSelectedGroupByValues.length > 0
            for dimValue in preSelectedGroupByValues
              view.groupByValues[dimIndex][dimValue] = true

            view.updateReport()

        # Invoked after 'Apply' has been clicked in the dimension editor.
        #
        # Don't open any group by value menus, but call categoryCache.getByDimension for each
        # dimension on the first metric so they'll be loaded when the user opens
        # the cache.
        view.dimensionEditorSubmitCallback = () ->
          view.updateReport()

          keyMetric = view.getKeyMetric()

          for dimension in keyMetric.dimensions when dimension.column_id isnt view.RJQL_STRING_CONSTANTS.RJQL_UNBOUND
            categoryCache.getByDimension(
              dimension
              keyMetric
            )

        # Pretty heinous that we have to call this in the view
        # We should come up with a better way to prevent
        # duplicate dimensions from being chosen
        view.dimAlreadyChosen = (dimensions) ->
          return (dimension) ->
            ids = dimensions.map (item) -> return item.column_id
            return ids.indexOf(dimension.column_id) < 0

        _isDimensionAvailable = (metrics, dimension) ->
          sourceMetrics = (metric for metric in metrics when metric.type is 'metric')
          for metric in sourceMetrics
            available = false
            for dim in metric.dimensionList
              if dim.column_id is dimension.column_id
                available = true
                break

            # If we haven't found it on a metric, we can stop looking
            if not available
              return false

          # If we made it through all the metrics, it's available
          return true

        # Checks to see if the dimension is available and if not,
        # opens the dimension editor
        _isDimensionAvailableAndResolveIt = (metrics, dimension) ->
          if _isDimensionAvailable(metrics, dimension)
            return true
          else
            # Show the dimension resolver modal
            view.showDimensionResolver(metrics, dimension)

            # Let the function know we can't do anything just yet
            return false

        view.removeAllDimensions = () ->
          if view.selectedMetrics.length > 0
            dimension = view.selectedMetrics[0].dimensions[0]
            if dimension?
              view.removeDimension(dimension, 0, false)
              view.removeAllDimensions()

        view.removeDimension = (dimension, position = -1, updateReport = true) ->
          keyMetric = view.getKeyMetric()

          keyMetric.dimensions = _removeIndexFromDimensions(keyMetric.dimensions)

          if position isnt -1
            for metric in view.selectedMetrics when metric.type is 'metric'
              metric.dimensions.splice(position, 1)

          # Also delete it from the saved groupByValues
          view.groupByValues.splice(position, 1)

          # Reset order by / data limit status referencing this dimension
          _removeDimFromOrder(dimension.column_id)

          if updateReport
            view.updateReport()

        # Makes sure order by isn't referencing a dimension we just removed
        _removeDimFromOrder = (column_id) ->
          for metric in view.selectedMetrics when metric.type is 'metric' and metric.order?
            if metric.order.fields[0][0] is column_id
              metric.order.fields[0][0] = ':value'
              metric.order.limit.take = '100%'

        view.setTimeInterval = (timeInterval) ->
          view.time.interval = timeInterval

        view.handleTimeRangeChange = (timerange) ->
          if timerange.start?.datetime? and timerange.end?.datetime? and not view.time.interval
            view.time.interval = dateService.getAppropriateTimeInterval(timerange.start.datetime, timerange.end.datetime, view.time.interval)

        # Helper for orderBy in angular
        view.getDimensionName = (dim) ->
          if dim.name?
            return dim.name
          else if view.columns?
            return view.columns[dim.column_id].name

        _getIndexByAlias = (metricAlias) ->
          for testMetric, metricIndex in view.selectedMetrics when testMetric.alias is metricAlias
            return metricIndex

        updateExpressionText = (formula, metricIndexToRemove) ->
          formula.expressionText = formula.expressionText.toString().replace(/[A-Z]+/g, (match) ->
            currentIndex = encodedLetterString.alphaToIndex(match)
            if currentIndex is metricIndexToRemove then return '<deleted>'
            else if currentIndex > metricIndexToRemove then newIndex = currentIndex - 1;
            else newIndex = currentIndex
            return encodedLetterString.numToLetter(newIndex)
          )

        # Called before a metric is removed.
        # Iterate over all of the formulas, and for each, decrement the index of any
        # referenced metrics whose index is greater than than metricIndexToRemove.
        _updateFormulaAliases = (metricIndexToRemove) ->
          for metric in view.selectedMetrics when metric.type is 'formula'
            updateExpressionText(metric, metricIndexToRemove)
            if metric.editingFormula?.expressionText?
              updateExpressionText(metric.editingFormula, metricIndexToRemove)

        # Delete by alias since letters and indexes can change during
        # deletion of dependent formulas
        _deleteMetric = (aliasToRemove) ->
          if aliasToRemove?
            delete view.metricValidity[aliasToRemove]
          deletionIndex = _getIndexByAlias(aliasToRemove)

          # Before we remove a metric, we have to update all the formulas that may be affected
          _updateFormulaAliases(deletionIndex)
          view.selectedMetrics.splice(deletionIndex, 1)
          setKeyMetric()

          view.time.intervalEnabled = view.canSelectTimeInterval()

          rjpopover.updateGroupLocation(view.RJPOPOVER_GROUP_NAME)

          if view.selectedMetrics.length < 1
            view.groupByValues = []
            view.cohortView = false
            view.time = reportBuilder.generateDefaultTime(DEFAULT_TIME_INTERVAL, RJQL_VERSION)

          view.checkIfCohortDisabled()

        _confirmAndDeleteFormulas = (formulaAliasesToDelete) ->
          if formulaAliasesToDelete.length > 0
            confirmText = "This metric is referenced by the following formula\
            #{if formulaAliasesToDelete.length > 1 then 's' else ''}, which will also be \
            deleted: '#{formulaAliasesToDelete.join("', '")}'"
            if confirm(confirmText)
              for formulaAliasToBeDeleted in formulaAliasesToDelete
                _deleteMetric(formulaAliasToBeDeleted)
            else
              return false

          return true

        _getDependentFormulas = (selectedIndex) ->
          letterOfMetric = encodedLetterString.numToLetter(selectedIndex)
          dependentFormulas = []
          for metric, metricIndex in view.selectedMetrics when metric.type is 'formula'
            # Replace all math operators, numerals, and decimal points in the expression with
            # spaces, then split on spaces, resulting in an array of letters used
            parsedLetters = metric.expressionText
                              .toString()
                              .replace(/[\d\(\)\+\-\*\/\.]/g, ' ')
                              .trim()
                              .split(/\s+/g)
            for letter in parsedLetters when letter is letterOfMetric
              dependentFormulas.push(metric.alias) ; break
          return dependentFormulas

        view.removeMetric = (selectedIndex) ->
          # Ensure there is at least one non-formula metric remaining after the
          # metric is deleted.
          metricToDelete = view.selectedMetrics[selectedIndex]

          if metricToDelete.type is "metric"
            formulaMetrics = view.selectedMetrics.filter (metric) ->
              metric.type isnt "metric"

            if formulaMetrics.length > 0 and formulaMetrics.length is view.selectedMetrics.length - 1
              alert "Your report must contain at least one metric that isn't a formula
                metric. To delete this metric, you must first add another metric."
              return

            if view.selectedMetrics.length > 1 and not _getMetricIndexWithBoundDimensions(view.selectedMetrics, selectedIndex)?
              alert "Your report must contain at least one metric with non-independent dimensions.
              Before deleting this metric, you must first add another metric or delete the associated group by."
              return

          view.updateActiveMetricIndex(selectedIndex)

          # If the metric menu is open for the metric being delete, hide the menu.
          # Otherwise, if the index is greater than the index to remove, decrement the index.
          if view.activeMetricMenu.index?
            if view.activeMetricMenu.index is selectedIndex
              view.activeMetricMenu.lastIndex = null # Also clear the last index so the menu disappears without animation
              view.activeMetricMenu.index = null
            else if view.activeMetricMenu.index > selectedIndex
              view.activeMetricMenu.index -= 1
              view.activeMetricMenu.lastIndex = view.activeMetricMenu.index # Disable animation.

          # Store the alias since its index can change as dependent formulas are deleted
          aliasToRemove = view.selectedMetrics[selectedIndex]?.alias
          if view.selectedMetrics[selectedIndex]?.type is 'metric'
            formulaAliasesToDelete = _getDependentFormulas(selectedIndex)
            # Dependencies are removed with additional logic and user interaction.
            # If this returns false then the user has canceled the metric removal
            if _confirmAndDeleteFormulas(formulaAliasesToDelete)
              _deleteMetric(aliasToRemove)
              view.updateReport()
          else
            # If the metric is a formula we can just delete it without checking for dependents
            _deleteMetric(aliasToRemove)
            view.updateReport()

          # If last metric were removed then clean notification 'Time Interval Mismatch'
          if view.selectedMetrics.length is 0
            _updateGlobalTimeIntervalMismatch()

        view.duplicateMetric = (index) ->

          oldMetric = view.selectedMetrics[index]
          newMetric = utils.copy(oldMetric)
          if newMetric.type is 'metric'
            _addMetric(newMetric, true, null).then (newMetric) ->
              view.metricValidity[newMetric.alias] = view.metricValidity[oldMetric.alias]
          else if newMetric.type is 'formula'
            # Make sure we don't have metrics with the same name
            newMetric.alias = _getUniqueMetricAlias(newMetric.alias)
            newMetric.uniqueId = getUniqueMetricId()
            view.metricValidity[newMetric.alias] = view.metricValidity[oldMetric.alias]
            view.selectedMetrics.push newMetric

          _newMetricIndicator(view.selectedMetrics.length)

        # Replace an existing metric with a different metric from the same table.
        view.swapMetric = (metric, newMetric) ->
          # Don't allow a metric to be swapped with itself
          return unless newMetric.name isnt metric.name or
            newMetric.id isnt metric.id

          oldAlias = metric.alias

          # If the metric's alias is its name, then update the alias to the new
          # name.
          if metric.alias is metric.name or
            stringService.checkGeneratedString(metric.name, metric.alias)
              metric.alias = _getUniqueMetricAlias(newMetric.name)

          metric.hasTimestamp = _metricHasTimestamp(newMetric)
          _addMetricInfoToMetric(newMetric, metric)
          if not metric.hasTimestamp
            metric.timeUnbound = true

          metric.id = newMetric.id
          metric.name = newMetric.name
          _addFilterInfoToMetric(metric)

          # Update the metric validity if necessary
          if metric.alias isnt oldAlias
            view.metricValidity[metric.alias] = view.metricValidity[oldAlias]
            delete(view.metricValidity[oldAlias])

          view.time.intervalEnabled = view.canSelectTimeInterval()
          unless metric.hasTimestamp
            view.setTimeInterval(TIME_INTERVAL_VALUES.NONE)

          view.updateReport()

        view.setChartType = (type, updateReport = true) ->

          unless view.figure.presentation.highcharts.chart?
            view.figure.presentation.highcharts.chart =
              type: type
          else
            view.figure.presentation.highcharts.chart.type = type

          highchart = view.figure.presentation.highcharts

          view.selectedChartType = type

          switch type
            when 'barstacked'
              highchart.chart.type = 'bar'
              highchart.plotOptions =
                bar:
                  stacking: 'normal'
            when 'columnstacked'
              highchart.chart.type = 'column'
              highchart.plotOptions =
                column:
                  stacking: 'normal'
            when 'area'
              highchart.chart.type = 'area'
              highchart.plotOptions =
                area:
                  stacking: 'normal'
            when 'bar'
              highchart.chart.type = 'bar'
              highchart.plotOptions =
                column:
                  stacking: null
            when 'column'
              highchart.chart.type = 'column'
              highchart.plotOptions =
                column:
                  stacking: null
            when 'scatter'
              highchart.chart.type = 'scatter'
              view.figure.presentation.hasTrendLine = false
            when 'scattertrendline'
              highchart.chart.type = 'scatter'
              view.figure.presentation.hasTrendLine = true
            when 'bubble'
              highchart.chart.type = 'bubble'
              view.figure.presentation.hasTrendLine = false
            when 'heatmap'
              highchart.chart.type = 'heatmap'
            else
              highchart.plotOptions =
                column:
                  stacking: null

          if updateReport
            view.updateReport()

        # Show confirmation message if user has unsaved changes in active metric or formula
        view.skipUnappliedFiltersAndFormulas = () ->
          if view.activeMetricIndex? and view.activeMetricIndex >= 0 and view.activeMetricIndex < view.selectedMetrics.length

            _getMessage = (text) -> "You've made changes to the #{text} for the active metric. Are you sure you want to continue without applying these changes?"
            activeMetric = view.selectedMetrics[view.activeMetricIndex]
            confirmationMessage = ""

            if activeMetric.type is 'metric'
              if !!activeMetric.filtersChanged
                confirmationMessage = _getMessage("filters")
              else if !!activeMetric.perspectiveChanged
                confirmationMessage = _getMessage("perspective")
              else if !!activeMetric.timeOptionsChanged
                confirmationMessage = _getMessage("time options")
            else if activeMetric.type is 'formula' and activeMetric.formulaChanged
              confirmationMessage = _getMessage("formula")

            if confirmationMessage
              unless confirm(confirmationMessage)
                return true

          return false

        view.removeActiveMetricIndex = () ->
          view.activeMetricIndex = null

        view.setActiveMetricIndex = (index) ->
          view.activeMetricIndex = index

        # If metric should be deleted and it is active then remove activeMetricIndex,
        # else recalculate new index depending on the relative position
        view.updateActiveMetricIndex = (index) ->
          if view.activeMetricIndex is null
            return
          else if view.activeMetricIndex is index
            view.removeActiveMetricIndex()
          else if view.activeMetricIndex > index
            view.activeMetricIndex -= 1

        # Used for determining whether or not a new metric can be added
        view.allMetricsValid = ->
          for metricAlias, metricValid of view.metricValidity
            if not metricValid or metricValid is 'blank'
              return false
          return true

        # Used for determining whether or not to disable the 'Select Interval...' dropdown
        view.canSelectTimeInterval = ->
          for metric in view.selectedMetrics when metric?
            if metric.type isnt 'formula'
              return false unless metric.hasTimestamp

          return true

        view.toggleMetricPlot = (metric) ->
          metric.plot = not metric.plot
          view.updateReport()

        view.selectMetric = (metricIndex) ->
          view.selectedMetricAlias = view.selectedMetrics[metricIndex].alias

        # Updates the validity map when an alias changes and reverts the alias
        # if it's blank or not unique
        view.validateAlias = (metricIndex, canRevert = false) ->
          newAlias = view.selectedMetrics[metricIndex].alias
          # Just return if we've called this function without the alias
          # actually changing.
          if newAlias is view.selectedMetricAlias
            return

          # If metric alias is unique and not blank
          if view.aliasIsUnique(metricIndex) and newAlias? and newAlias isnt ''
            # Update validity map, setting new name as the key
            view.metricValidity[newAlias] = view.metricValidity[view.selectedMetricAlias]
            delete view.metricValidity[view.selectedMetricAlias]
            # And update the selectedMetricAlias in case we need to revert to this
            view.selectedMetricAlias = newAlias
          else # Revert metric if input is blurred
            if canRevert
              view.selectedMetrics[metricIndex].alias = view.selectedMetricAlias

        view.gotoDashboard = (id) ->
          # Send them back to the dashboard they came from or the default dashboard
          $location.url appRoute("/#{id}")

        view.toggleTranspose = () ->
          transpose = not view.figure.presentation.table.transpose
          view.figure.presentation.table.transpose = transpose

        view.toggleFreezeColumns = () ->
          freezeColumns = not view.figure.presentation.table.freezeColumns
          view.figure.presentation.table.freezeColumns = freezeColumns

        view.showFreezeToggleControl = () ->
          if not view.figure.query?
            return false
          figureDimensions = figureService.getDimensionsFromFigure(view.figure)
          dimensions = figureDimensions[0]
          dimensions ?= []
          if dimensions.length > 0 and view.time.interval isnt TIME_INTERVAL_VALUES.NONE
            return true
          return false

        # When adding metrics, we have to be careful not to try and add dimensions that aren't
        # available to certain metrics. In those cases, pop up a modal to make the user resolve
        # any conflicts between dimensions.
        view.resolveDimensions = (dimensionPromise, metrics, keyMetric) ->
          resolvedDimensions = $q.defer()
          # When the dimension list arrives execute this
          $q.when(dimensionPromise).then (response) ->
            if keyMetric?
              currentDimensions = utils.copy(keyMetric.dimensions)
            else
              currentDimensions = []

            # If this metric already has dimensions, we're probably loading it so assume its good
            if response.dimensions?.length > 0
              resolvedDimensions.resolve(response.dimensions)
            else if reportBuilder.hasCurrentDimensionsAvailable(response, currentDimensions)
              resolvedDimensions.resolve(currentDimensions)
            else
              view.showMetricResolver(metrics, response, resolvedDimensions)

          return resolvedDimensions

        view.hasDimensions = () ->
          keyMetric = view.getKeyMetric()
          if TIME_BASED_COHORT_GROUPING_ENABLED
            if view.cohortView
              return keyMetric.dimensions.length > 1
            else
              return keyMetric.dimensions.length > 0
          else
            return keyMetric.dimensions.length > 0

        # Do we have any data perspectives that prevent us from adding a 2nd dimension?
        view.canAddDimension = () ->
          keyMetric = view.getKeyMetric()
          # Get all currently used data perspectives
          perspectives = _getCurrentlyUsedDataPerspectives()
          dimensionCount = keyMetric.dimensions.length

          # Once we have more than 2 dimensions there are some restrctions on data perspectives
          if dimensionCount >= 1
            # Check to see if they're on the list of ones restricted to one dimension
            for perspective in perspectives
              if reportBuilder.isOneDimensionOnlyPerspective(perspective)
                return false

          return true

        view.isShowTopBottomAvailable = () ->
          return !view.cohortView and
            view.hasDimensions() and
            view.time.interval is TIME_INTERVAL_VALUES.NONE

        view.isGroupByMenuAvailable = () ->
          if TIME_BASED_COHORT_GROUPING_ENABLED
            return not (view.cohortView and view.getKeyMetric().dimensions[0].datatype isnt DATE_COLUMN_TYPE)
          else
            return not view.cohortView

        _getCurrentlyUsedDataPerspectives = () ->
          perspectives = (view.selectedMetrics.map (metric) -> return metric.perspective)
          return perspectives

        # Are there any restrictions to adding this perspective to this metric?
        view.isPerspectiveAllowed = (metric, perspective) ->
          reportBuilder.isPerspectiveAllowed(metric, perspective, view.cohortView, RJQL_VERSION)

        # Update some presentation loose ends
        _updatePresentationFromScope = () ->
          if not view.figure.presentation.highcharts.chart.legend?
            view.figure.presentation.highcharts.chart.legend = {}

          view.figure.presentation.hasTrendLine = view.hasTrendLine.checked
          view.figure.presentation.highcharts.chart.legend.enabled = view.chartLegendVisible.checked
          view.figure.presentation.table?.freezeColumns = view.freezeColumnOptions.checked

        view.toggleShowChart = () ->
          view.showChart = not view.showChart
          view.figure.presentation.reportBuilder?.chart.visible = view.showChart
          # If we're unhiding it, we should re-render it
          if view.showChart
            view.updateReport()

        view.toggleShowTable = () ->
          view.showTable = not view.showTable
          view.figure.presentation.reportBuilder?.table.visible = view.showTable
          # If we're unhiding it, we should re-render it
          if view.showTable
            view.updateReport()

        view.sortableDimensionsOptions = () ->
          prevIndex = -1
          newCollection = []

          arrayMove = (collection, prevIndex, newIndex) ->
            toMove = collection.splice(prevIndex,1)[0]
            collection.splice(newIndex,0,toMove)
            collection

          axis: 'xy'
          cursor: 'auto'
          appendTo: '.chart-options__sortable-dimensions'
          distance: 1
          tolerance: "pointer"
          containment: ".chart-options"
          opacity: 0.5
          cancel: '.dont-sort'
          start: ( event, ui ) ->
            rjpopover.hideGroup(view.RJPOPOVER_GROUP_NAME)
            prevIndex = ui.item.index()
          update: ( event, ui ) ->
            newIndex = ui.item.index()

            $timeout(() ->
              selectedMetrics = utils.copy(view.selectedMetrics)
              groupByValues = utils.copy(view.groupByValues)

              keyMetric = selectedMetrics[view.keyMetricIndex]

              # remove indices from dimensions to allow tracking and sorting
              keyMetric.dimensions = _removeIndexFromDimensions(keyMetric.dimensions)

              modifiedSelectedMetrics = _.map(selectedMetrics, (metric) ->
                metric.dimensionValues = arrayMove(metric.dimensionValues, prevIndex, newIndex)
                # formula metrics don't have dimensions so don't re-order them
                if metric.type isnt "formula" and metric.dimensions?
                  metric.dimensions = arrayMove(metric.dimensions, prevIndex, newIndex)
                return metric
              )

              view.groupByValues = arrayMove(groupByValues, prevIndex, newIndex)
              view.selectedMetrics = modifiedSelectedMetrics

              # Set the Figure
              view.figure.query.select.rows = _.map(keyMetric.dimensions, (dimension) ->
                dimension.name
              )
              view.updateReport()
            , 0)

        view.toggleMetricMenu = ($index, menu) ->
          if view.activeMetricMenu.index is $index and view.activeMetricMenu.menu is menu
            view.activeMetricMenu.lastIndex = view.activeMetricMenu.index # Animate the menu close
            view.activeMetricMenu.index = null
            view.activeMetricMenu.menu = null
          else
            view.activeMetricMenu.lastIndex = view.activeMetricMenu.index # Animate the menu change
            view.activeMetricMenu.index = $index
            view.activeMetricMenu.menu = menu
          rjpopover.updateGroupLocation(view.RJPOPOVER_GROUP_NAME)

        view.updateMetricValidity = () ->
          for metric in view.selectedMetrics
            view.metricValidity[metric.alias] = reportBuilder.metricIsValid(metric)

        # Show the dimension grid modal dialog with the specified scope.
        _showModalWithScope = (scope) ->
          $modal(
            template: 'modal.dimensionGrid.html'
            modalClass: 'dimension-grid'
            show: true
            scope: scope
            backdrop: true
            backdropClass: 'dimension-grid-background'
          )

        # Show the metric resolver. `resolvedDimensionsPromise` is resolved with a
        # list of dimensions for `newMetric` if the 'Apply' button is clicked.
        view.showMetricResolver = (metrics, newMetric, resolvedDimensionsPromise) ->
          modalScope = dimensionService.getMetricResolverScope(metrics, newMetric, resolvedDimensionsPromise)
          _showModalWithScope(modalScope)

        # Show the dimension editor.
        # Invoke `callback` with `index` when 'Apply' is clicked.
        view.showDimensionEditor = () ->
          modalScope = dimensionService.getDimensionEditorScope(view.selectedMetrics, view.dimensionEditorSubmitCallback)
          _showModalWithScope(modalScope)

        # Show the dimension resolver for the new `dimension`.
        # Invoke `callback` with when 'Apply' is clicked.
        view.showDimensionResolver = (metrics, dimension) ->
          modalScope = dimensionService.getDimensionResolverScope(metrics, dimension, view.dimensionEditorSubmitCallback)
          _showModalWithScope(modalScope)

        updateFormulaAliases = (metrics) ->
          for metric in metrics when \
            metric.type is 'formula' and metric.expression?

              metric.expressionText =
                rjqlFormula.convertPrefixMetricExpressionToInfixFormula(
                  metric.expression
                  metrics
                )

              if metric.editingFormula?.expression? and
                metric.editingFormula.valid
                  metric.editingFormula.expressionText =
                    rjqlFormula.convertPrefixMetricExpressionToInfixFormula(
                      metric.editingFormula.expression
                      metrics
                    )

        handleMetricReordering = (newIndex, oldIndex) ->
          if newIndex isnt oldIndex
            # Reorder the metrics
            utils.changePosition(view.selectedMetrics, newIndex, oldIndex)

            # Update the active metric id
            if view.activeMetricIndex?
              view.activeMetricIndex =
                getChangedIndex(view.activeMetricIndex, newIndex, oldIndex)

            # Give each metric a new uniqueId, which causes Angular to recompile each
            # element's DOM, which is how we get Angular to deal with the changes to
            # the DOM caused by sorting.
            for metric in view.selectedMetrics
              metric.uniqueId = getUniqueMetricId()

            updateFormulaAliases(view.selectedMetrics)

            setKeyMetric()

            # Move the metric menu, if necessary
            # Set the last index to an invalid index to supress animation
            if view.activeMetricMenu.index is newIndex
              view.activeMetricMenu.index = oldIndex
              view.activeMetricMenu.lastIndex = -1
            else if view.activeMetricMenu.index is oldIndex
              view.activeMetricMenu.index = newIndex
              view.activeMetricMenu.lastIndex = -1

            view.updateReport()

          else
            # Even though the list of metrics hasn't changed, force a DOM refresh
            # (since we modified the DOM when adding the drag placeholder.)
            metrics = utils.copy(view.selectedMetrics)
            for metric in metrics
              metric.uniqueId = getUniqueMetricId()
            view.selectedMetrics = metrics

        getChangedIndex = (index, newIndex, oldIndex) ->
          lastIndex = Math.max(index, newIndex, oldIndex)
          items = [0..lastIndex].map (_index) -> _index is index
          utils.changePosition(items, newIndex, oldIndex)
          items.indexOf(true)

        view.metricsSorted = (newIndex, oldIndex) ->
          $timeout () ->
            handleMetricReordering(newIndex, oldIndex)

            # Remove any visible tooltips associated with DOM elements which no
            # longer exist.
            $rootScope.$broadcast('hide-tooltips')

          , 0

        # Iterate over all of the selectedMetrics and make sure everything is
        # valid before allowing metrics to be dragged.
        view.dragStartClick = () ->
          rjpopover.hideGroup(view.RJPOPOVER_GROUP_NAME)
          for metric in view.selectedMetrics
            metricIsInvalid = not view.metricValidity[metric.alias] or
              view.metricValidity[metric.alias] is 'blank'

            editingFormulaIsInvalid = metric.type is 'formula' and
              metric.editingFormula? and
              (not metric.editingFormula.valid or metric.editingFormula.valid is 'blank')

            if metricIsInvalid or editingFormulaIsInvalid
              alert "Fix the error on the '#{metric.alias}' metric before changing
                     metric order."

              return false

          return true

        view.$onInit = () ->
          if app.isReadOnlyUser()
            $location.path(appRoute("/"))

          overdueBillingModalService.showModalIfOverdue($scope)
          notification.clear("report")
          view.setChartType('line')
          $q.all(loadResourcePromises).then((results) ->
            view.metrics = view.metrics.map (m) ->
              m.tableName = view.tables[m.table_id]?.name
              m

            if hasFigureId
              view.loadFigure()
            else
              _logEvent("Report Builder Usage")

            view.isLoading.resources = false
          )
        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch 'view.cohortView', (cohortView, old) ->
        if cohortView isnt old
          if cohortView
            view.chartTypes = view.COHORT_CHART_TYPES
          else
            view.chartTypes = view.CHART_TYPES
            

      # Update the title of the window whenever the name of the figure changes
      scope.$watch 'view.figure.name', (newName, old) ->
        dashboardService.setWindowTitle(if newName? and newName isnt '' then "#{newName}" else "Adobe Commerce Intelligence - Report Builder")

      scope.$watch 'view.time', (newTime, oldTime) ->
        if not angular.equals(oldTime, newTime)
          view.handleTimeRangeChange(newTime.timerange)
          view.updateReport()
      , true

      scope.$on '$locationChangeStart', (event) ->
        # Confirm user wishes to navigate away from Report Builder if...
        #  - They aren't saving and
        #    - They're creating a new figure and have added at least one metric or
        #    - They've opened an existing figure and have changed it
        if view.figure.error is null then view.pristineFigure.error = null

        if view.skipUnappliedFiltersAndFormulas()
          event.preventDefault()
          return

        if ((not view.figure.id? and view.selectedMetrics.length > 0) or
          (view.figure.id? and view.pristineFigure? and not angular.equals(view.figure, view.pristineFigure))) and
            not view.savingInProgress
          leaveReportBuilder = confirm("Are you sure you want to leave without saving?")
          if not leaveReportBuilder
            event.preventDefault()
]
